import BSTreeViewMethodOptions from './BSTreeViewMethodOptions';
/**
 * The options for TreeView disable/enable functions
 */
export default class BSTreeViewDisableOptions extends BSTreeViewMethodOptions {
}
